import { getToken } from "utils/helper";
import { CustomApiResponse } from "utils/helper/ApiResponses";
import { DashboardStats } from "utils/types";
import { apiSrcUrl } from "../ApiRoutes";
import { ApiService } from "../apiservices";

// Defines the parameters for fetching dashboard data
export interface FetchDashboardParams {
  period: 'week' | 'month' | 'year';
  startDate: string;
  endDate: string;
  countryCode?: string; // Optional country filter for admins
}

/**
 * Fetches aggregated dashboard statistics from the backend.
 * @param params - The query parameters for time period, date range, and country.
 * @returns A promise that resolves to the dashboard statistics.
 */
export const getDashboardStats = async (
  params: FetchDashboardParams
): Promise<DashboardStats> => {
  if (!apiSrcUrl) {
    throw new Error("API source URL is not configured.");
  }
  const token = getToken();
  if (!token) {
    throw new Error("Authentication token not found.");
  }

  const query = new URLSearchParams({
    period: params.period,
    startDate: params.startDate,
    endDate: params.endDate,
  });

  // Only add the countryCode to the query if it's provided
  if (params.countryCode) {
    query.append("countryCode", params.countryCode);
  }

  const url = `${apiSrcUrl}/private/dashboard?${query.toString()}`;

  const response = await ApiService.get<CustomApiResponse<DashboardStats>>(url, {
    Authorization: `Bearer ${token}`,
  });

  if (response.data.status !== 'success' || !response.data.data) {
    throw new Error(response.data.message || "Failed to fetch dashboard stats.");
  }

  return response.data.data;
};

